import { createApi } from '@reduxjs/toolkit/query/react';

import select from 'store/select';
import fusionFetchBase from './fusionFetchBase';
import FusionQueryError from './FusionQueryError';
import { reportAllErrors, reportStatusCodes } from './fusionEndpointErrorHandlers';

const fusionApi = createApi({
  reducerPath: 'fusion',
  baseQuery: fusionFetchBase,
  keepUnusedDataFor: 60 * 60, // 60 minutes
  endpoints: (builder) => ({
    getSpecialties: builder.query({
      query: () => '/specialties/',
      transformErrorResponse: reportAllErrors,
    }),

    getPromotions: builder.query({
      queryFn: async (arg, rtk, extra, fetchClient) => {
        const clientSlug = select.client.slug(rtk.getState());

        let url = `/promotions/?client_slug=${clientSlug}`;

        if (arg) {
          const params = new URLSearchParams(arg);
          url += `&${params.toString()}`;
        }

        const response = await fetchClient(url);

        if (response.error) {
          const error = new FusionQueryError(response, arg);
          error.report();
        }

        return response;
      },
    }),

    getAggregations: builder.query({
      query: ({ type = 'providers', ...params }) => ({ url: `/${type}/aggregations/`, params }),
      transformErrorResponse: reportStatusCodes(404),
      keepUnusedDataFor: 60 * 5, // 5 minutes
    }),

    getResultCount: builder.query({
      query: ({ type = 'providers', ...params }) => ({ url: `/${type}/count/`, params }),
      transformErrorResponse: reportStatusCodes(404),
      keepUnusedDataFor: 60 * 5, // 5 minutes
    }),

    getAutocomplete: builder.query({
      query: (params) => ({ url: '/autocomplete/', params }),
    }),
  }),
});

export default fusionApi;

// the reason for explicitly creating this object is to get intellisense on this objects keys
export const hooks = {
  useGetSpecialtiesQuery: fusionApi.useGetSpecialtiesQuery,
  useGetPromotionsQuery: fusionApi.useGetPromotionsQuery,
  useGetAggregationsQuery: fusionApi.useGetAggregationsQuery,
  useGetResultCountQuery: fusionApi.useGetResultCountQuery,
  useGetAutocompleteQuery: fusionApi.useGetAutocompleteQuery,
};
